import ToolButton from "./toolButton";
import SelectionResultsTable from "./SelectionResultTable";

// toggleResultsTool

export default class ToggleResultsTool extends ToolButton {
  deactivateTool() {
    // console.log("toggleResultsTool deactivateTool")
  }

  activateTool(event: any) {
    // console.log("toggleResultsTool start", this.view);
    try {
      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        const selectionResultsTable = new SelectionResultsTable(this);
        selectionResultsTable.toggleResultsTable();
      }
      this.toolbar.setPanAsActiveTool();
    } catch (error) {
      console.error("Error: in toggleResultsTool " + +error.message);
    }
  }
}
